import { professionReportsContract } from './professionReports.contract';
import { mainPageContract } from './mainPage.contract';
import { tagsContract } from './tags.contract';
import { progressContract } from './progress.contract';
import { analysisContract } from './analysis.contract';

// Individual re-exports (for route files importing specific contracts)
export {
	professionReportsContract,
	productivityV1StreamRoute,
	productivityV2StreamRoute,
	safetyStreamRoute,
	activitiesStreamRoute,
} from './professionReports.contract';
export type { ProductivityStreamQuery } from './professionReports.contract';

export {
	mainPageContract,
	mainPageProfessionsStreamRoute,
	mainPageFloorsStreamRoute,
	workplanWidgetStreamRoute,
} from './mainPage.contract';
export type { MainPageStreamQuery } from './mainPage.contract';

export { tagsContract } from './tags.contract';

export { progressContract } from './progress.contract';

export { analysisContract } from './analysis.contract';

// Aggregated export for service client creation (auto-discovery by createServiceClient)
export const reportsEngineContracts = {
	professionReportsContract,
	mainPageContract,
	tagsContract,
	progressContract,
	analysisContract,
};
